import moment from 'moment'
import Vue from 'vue'
export default {
  securityToken: function(state) {
    return 'BEARER ' + state.userid + ' ' + state.accessToken
  },
  isLoading: function(state) {
    return state.loading
  },
  isLoggedIn: function(state) {
    return state.isLoggedIn
  },
  unsubscribedPage: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        if (!isFound) {
          pagelist.push(pageValue)
        }
      })
    }

    return pagelist
  },
  allPage: function(state) {
    let pagelist = []

    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }

    return pagelist
  },
  selectedBot: function(state) {
    if (state.selectedBot == null) {
      return null
    }
    return state.selectedBot
  },
  botlist: function(state) {
    return state.botlist
  },
  isSelectedBot: function(state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function(state) {
    return state.paypalTrackingId
  },
  setting: function(state) {
    return state.setting
  },
  welcomeMessage: function(state) {
    return state.welcomeMessage
  },
  showModalWelcome: function(state) {
    return state.showModalWelcome
  },
  isFacebook: function(state) {
    return state.isFacebook
  },
  getPackage: function(state) {
    var now = moment()
    if (!state.selectedBot) {
      return 'normal'
    }
    var date = moment(state.selectedBot.expireat)
    var expriedTime = parseInt(date.diff(now, 'seconds'))
    return expriedTime > 0 ? 'premium' : 'normal'
  },
  currentLang: function(state) {
    return Vue.i18n.locale()
  },
  showAlert: state => type => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function(el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getLoadingSetting: function(state) {
    return state.loadingSetting
  },
  getSetting: function(state) {
    return state.setting
  },
  getLoadingApiList: function(state) {
    return state.loadingApiList
  },
  getApiList: function(state) {
    return state.apiList
  },
  getLoadingFlowList: function(state) {
    return state.loadingFlowList
  },
  getFlowList: function(state) {
    if (state.flowList && state.flowList.length > 0)
      return state.flowList.sort((a, b) => {
        if (a.flowname < b.flowname) {
          return -1
        }
        if (a.flowname > b.flowname) {
          return 1
        }
        return 0
      })
    else return []
  },
  getLoadingVariableList: function(state) {
    return state.loadingVariableList
  },
  getVariableList: function(state) {
    return state.variableList
  },
  getFlowId: function(state) {
    return state.selectedFlow
  },
  getCopyNodes: function(state) {
    return state.copyNodes
  },
  getLoadingAdminList: function(state) {
    return state.loadingAdminList
  },
  getAdminList: function(state) {
    if (!state.adminList) {
      return []
    }
    return state.adminList.sort((a, b) => {
      if (a.adminid.toLowerCase() < b.adminid.toLowerCase()) {
        return -1
      } else if (a.adminid.toLowerCase() > b.adminid.toLowerCase()) {
        return 1
      }
      return 0
    })
  },
  getLoadingBotOrigins: function(state) {
    return state.loadingBotOrigins
  },
  getBotOrigins: function(state) {
    return state.botOrigins
  },
  getLoadingPersistentMenu: function(state) {
    return state.loadingPersistentMenu
  },
  getPersistentMenu: function(state) {
    return state.persistent_menu
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js